import { withPropsOnChange } from 'recompose';
import { mapCoachButton } from '../../../helpers/custom-page/manual-coach';
import { ManualCoach as Coach } from '../../../widgets/manual-coach-widget';

export const Component = ({ text, primaryButton, secondaryButton }) => (
  <Coach message={text} primaryButton={primaryButton} secondaryButton={secondaryButton} />
);

export const ManualCoach = withPropsOnChange(
  ['primaryButton', 'secondaryButton'],
  ({ primaryButton, secondaryButton }) => ({
    primaryButton: mapCoachButton(primaryButton),
    secondaryButton: mapCoachButton(secondaryButton)
  })
)(Component);
